export const foundersSlides = [
    {
        mobile_image: 'images/program_section/mobile/FUNDAMENTALS_OF_ENTREPRENEURSHIP.jpg',
        image: 'images/program_section/FUNDAMENTALS_OF_ENTREPRENEURSHIP.png',
        heading: 'FUNDAMENTALS <br> OF ENTREPRENEURSHIP',
        time: 'Virtual - 2 Weeks',
        content: 'Be a Startup Hero in 30 hours. 15 days live online program;'+
        ' 2 hours daily, first hand connections, networking with over 50 Silicon '+
        'Valley experts and mentors, and global entrepreneurs. ',
        link: '/program_fundamental',
    },
    {
        mobile_image: 'images/program_section/mobile/HERO_TRAINING.jpg',
        image: 'images/program_section/HERO_TRAINING.png',
        heading: 'HERO <br> TRAINING',
        time: 'Silicon Valley - 5 Weeks',
        content: 'Draper University Hero Training is an intensive, '+
        'immersive five-week entrepreneurship program in Silicon Valley, CA.'+
        ' During your stay at our San Mateo campus, you will develop the essential '+
        'startup skills you need to launch and sustain a successful venture, gain exposure to industry '+
        'experts and network with other like-minded entrepreneurs who share your vision of changing the world.'+
        ' By the time you graduate, you will have gone from human to hero. ',
        link: '/program_hero',
    },
];
export const executivesSlides = [
    {
        mobile_image: 'images/program_section/mobile/CORPORATE_INNOVATION_PROGRAM.jpg',
        image: 'images/program_section/CORPORATE_INNOVATION_PROGRAM.png',
        heading: 'CORPORATE <br> INNOVATION PROGRAM',
        time: 'Virtual - 5 Days',
        content: 'Draper University Executive Innovation Program is an intensive 5-day program for startup '+
        'and corporate executives who want an introduction to the Silicon Valley mindset, culture,'+
        ' and upcoming disruptive technologies. After attending this program, you will have the necessary '+
        'knowledge, experience, and leadership skills to bring innovation back to your company and team.',
        link: '/program_coporative',
    },
    {
        mobile_image: 'images/program_section/mobile/ACCELERATORS.jpg',
        image: 'images/program_section/ACCELERATORS.png',
        heading: 'CORPORATE <br> ACCELERATORS',
        time: 'Silicon Valley - 5 Weeks',
        content: 'Future-proof your business by investing and building with the most exciting startups in your '+
        'industry. Our global network, combined with our data driven model of startup acceleration '+
        'delivers a winning strategy for your innovation goals. ',
        link: '/program_coporative_accelerator',
    },
    {
        mobile_image: '/images/blockchain_page/Blockmobile.png',
        image: '/images/blockchain_page/BlockchainAccceleratorsimage1.png',
        heading: 'BLOCKCHAIN <br> ACCELERATORS',
        time: 'Silicon Valley - 5 Weeks',
        content: 'Blockchain technology has taken the world by storm, '+
        'and there is no denying its growing prominence in everyday life. Partner with Draper '+
        'to accelerate your blockchain ecosystem with superhero founders.',
        link: '/program_blockchain',
    },
];
export const investorsSlides = [
    {
        mobile_image: 'images/program_section/mobile/VcX.jpg',
        image: 'images/program_section/VcX.png',
        heading: 'VcX',
        time: '',
        content: 'Through a six day hands-on experience, VCx bridges the new generations '+
        'of entrepreneurial families around the world with Venture Capital’s '+
        'ground zero: top Silicon Valley VCs and founders leading the future.',
        link: 'program_vcx',
    },
    {
        mobile_image: 'images/program_section/mobile/WITH_US.jpg',
        image: 'images/program_section/WITH_US.png',
        heading: 'INVEST <br> WITH US',
        time: '',
        content: 'We invest in founders building the future. If you want to get involved with pre-seed '+
        'to pre-series A companies, join our investor network!',
        link: '/program_invest',
    },
];
export const governmentSlides = [
    {
        mobile_image: 'images/program_section/mobile/govt_WITH_US.jpg',
        image: 'images/program_section/govt_WITH_US.png',
        heading: 'GLOBAL GOVERNMENTS PARTNERSHIP',
        time: '',
        content: 'With 34+ global partners, we work with diverse markets, institutions and organizations powered by '+
        'global governments to fuel the growth of innovation hubs around the world. <br> Our programs are focused on '+
        'upskilling the youth, entrepreneurship, leadership and job creation in the market. ',
        link: '/program_global',
    },
]
;
